/** @format */

import { action } from 'easy-peasy';

const TopSection = {
	spacerHeight: 0,

	//Thunks
	setSpacerHeight: action((state, h) => {
		state.spacerHeight = h;
	}),
};

export default TopSection;
